<template>
  <div class="sp_registerThree">
    <el-form :model="registerThreeFrom"
             :rules="registerThreeRules"
             ref="registerThreeFrom">
      <!-- 密码区域开始 -->
      <h3>Password</h3>
      <el-row :gutter="30">
        <el-col :span="12">
          <el-form-item :label="$t('loginModule.password')+'：'"
                        prop="password">
            <el-input placeholder="Please input password"
                      autocomplete="new-password"
                      :type="passwordType"
                      v-model.trim="registerThreeFrom.password">
              <svg-icon class="password-icon"
                        :icon-class="passwordType == 'password' ? 'hide' : 'view'"
                        slot="suffix"
                        @click.native="passwordView"></svg-icon>
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="30">
        <el-col :span="12">
          <el-form-item :label="$t('loginModule.confirmPassword2')+'：'"
                        prop="confirmPassword">
            <el-input placeholder="Please confirm password"
                      autocomplete="new-password"
                      :type="confirmPassType"
                      v-model.trim="registerThreeFrom.confirmPassword">
              <svg-icon class="password-icon"
                        :icon-class="confirmPassType == 'password' ? 'hide' : 'view'"
                        slot="suffix"
                        @click.native="confirmPassView"></svg-icon>
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <!-- 密码区域结束 -->

      <!-- 公司信息区域开始 -->
      <h3>Company Information</h3>
      <el-row :gutter="30">
        <el-col :span="12">
          <el-form-item :label="$t('loginModule.companyName')+'：'"
                        prop="companyName">
            <el-input placeholder="Please input company name"
                      type="text"
                      v-model="registerThreeFrom.companyName"
                      :disabled="registerThree.companyName!==''&&registerThree.companyName !=='new company'"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$t('loginModule.tel')+'：'"
                        prop="companyPhone"
                        class="sp_telSelect">
            <el-input type="number"
                      class="input-with-select"
                      v-model="registerThreeFrom.companyPhone"
                      :disabled="registerThree.companyName!==''&&registerThree.companyName !=='new company'"
                      placeholder="Please input the region code or phone.">
              <el-select no-match-text="No Data"
                         remote
                         filterable
                         :remote-method="remoteMethod"
                         @visible-change="areaCodeFocus"
                         v-model="registerThreeFrom.companyAreaCode"
                         slot="prepend"
                         placeholder="Code"
                         :disabled="registerThree.companyName!==''&&registerThree.companyName !=='new company'">
                <el-option :label="val.areaCode"
                           :value="val.id"
                           v-for="val in areaCodelist"
                           :key="val.id">{{val.country+' '+val.areaCode}}</el-option>
              </el-select>
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="30">
        <el-col :span="12">
          <el-form-item :label="$t('loginModule.industry')+'：'">
            <el-cascader clearable
                         style="width:100%;"
                         v-model="registerThreeFrom.industry"
                         placeholder="Please select industry."
                         :options="filterIndustryList"
                         :props="industryProps"
                         :disabled="registerThree.companyName!==''&&registerThree.companyName !=='new company'"></el-cascader>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="30">
        <el-col :span="12">
          <el-form-item :label="$t('loginModule.countryRegion')+'：'"
                        prop="region">
            <el-select filterable
                       style="width:100%;"
                       v-model="registerThreeFrom.region"
                       placeholder="Please select country/region."
                       @change="changeCountry"
                       :disabled="registerThree.companyName!==''&&registerThree.companyName !=='new company'">
              <el-option :label="val.name"
                         :value="{value:val.value,remark:val.remark,name:val.name}"
                         v-for="val in countryList"
                         :key="val.value"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$t('loginModule.state')+'：'"
                        prop="state">
            <el-select filterable
                       style="width:100%;"
                       v-model="registerThreeFrom.state"
                       placeholder="Please select state."
                       @change="changeState"
                       :disabled="registerThree.companyName!==''&&registerThree.companyName !=='new company'">
              <el-option :label="val.name"
                         :value="{value:val.id,name:val.name}"
                         v-for="(val,index) in stateList"
                         :key="index"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$t('loginModule.city')+'：'"
                        prop="city">
            <el-select filterable
                       style="width:100%;"
                       v-model="registerThreeFrom.city"
                       placeholder="Please select city."
                       :disabled="registerThree.companyName!==''&&registerThree.companyName !=='new company'">
              <el-option :label="val.name"
                         :value="{value:val.id,name:val.name}"
                         v-for="val in cityList"
                         :key="val.id"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$t('loginModule.address')+'：'"
                        prop="address">
            <el-input type="text"
                      v-model="registerThreeFrom.address"
                      :disabled="registerThree.companyName!==''&&registerThree.companyName !=='new company'"
                      placeholder="Please input address."></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <!-- 公司信息区域结束 -->

      <!-- 个人信息区域开始 -->
      <h3>Personal Information</h3>
      <el-row :gutter="30">
        <el-col :span="12">
          <el-form-item :label="$t('loginModule.firstName')+'：'"
                        prop="firstName">
            <el-input v-model="registerThreeFrom.firstName"
                      placeholder="Please input first name."></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$t('loginModule.lastName')+'：'"
                        prop="lastName">
            <el-input v-model="registerThreeFrom.lastName"
                      placeholder="Please input last name."></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$t('loginModule.tel')+'：'"
                        prop="phone"
                        class="sp_telSelect">
            <el-input v-model="registerThreeFrom.phone"
                      type="number"
                      class="input-with-select"
                      placeholder="Please input the region code or phone.">
              <el-select filterable
                         no-match-text="No Data"
                         remote
                         :remote-method="remoteMethod"
                         @visible-change="areaCodeFocus"
                         v-model="registerThreeFrom.areaCode"
                         slot="prepend"
                         placeholder="Code">
                <el-option :label="val.areaCode"
                           :value="val.id"
                           v-for="val in areaCodelist"
                           :key="val.id">{{val.country+' '+val.areaCode}}</el-option>
              </el-select>
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <!-- 个人信息区域结束 -->

      <!-- 按钮区域开始 -->
      <el-row class="register">
        <el-col :span="12">
          <el-form-item style="text-align:center;">
            <el-button :loading="registerLoad"
                       style="width:50%;height:48px; font-size:16px;"
                       type="primary"
                       @click="register('registerThreeFrom')">{{$t('loginModule.register')}}</el-button>
            <p class="sp_register_skip">{{$t("loginModule.haveAccount")}}&nbsp;<router-link :to="{path:'/login'}">{{$t("loginModule.login")}}</router-link>
            </p>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <p class="sp_login_copyRight">Sangfor Official WebsiteSangfor Community Copyright 2021 SANGFOR TECHNOLOGIES INC.</p>
  </div>
</template>

<script>
import { register, checkCompany, getCorpByName, getState, getCity, getCountry, getStatesByGSMCountryId, } from "@/api/loginApi.js"

import { registerEncrypt } from "@/utils/encrypt.js"
export default {
  name: "registerThree",
  props: {
    registerThree: {
      type: Object,
      required: true,
      default: () => { },
    }
  },
  data () {
    var checkPassword = (rule, value, callback) => {
      const Reg = /^(?!.*\s)(?=.*[a-zA-Z])(?=.*[0-9])(?=.*[\W_]).{8,16}$/
      if (!value) {
        return callback(new Error("Please input the password."))
      } else {
        if (Reg.test(value)) {
          if (this.registerThreeFrom.confirmPassword) {
            if (this.registerThreeFrom.password === this.registerThreeFrom.confirmPassword) {
              const _this = this
              _this.$refs.registerThreeFrom.clearValidate('confirmPassword')
              return callback()
            } else {
              return callback("Those passwords didn't match. Try again.")
            }
          } else {
            return callback()
          }
        } else {
          return callback(new Error("Use 8 to 16 characters with a mix of letters, numbers & symbols."))
        }
      }
    }
    var checkConfirmPas = (rule, value, callback) => {
      const Reg = /^(?!.*\s)(?=.*[a-zA-Z])(?=.*[0-9])(?=.*[\W_]).{8,16}$/
      if (!value) {
        return callback(new Error("Please confirm the password again."))
      } else {
        if (Reg.test(value)) {
          if (this.registerThreeFrom.confirmPassword) {
            if (this.registerThreeFrom.password === this.registerThreeFrom.confirmPassword) {
              const _this = this
              _this.$refs.registerThreeFrom.clearValidate('password')
              return callback()
            } else {
              return callback("Those passwords didn't match. Try again.")
            }
          } else {
            return callback()
          }
        } else {
          return callback(new Error("Use 8 to 16 characters with a mix of letters, numbers & symbols."))
        }
      }
    }
    var checkCompanyName = (rule, value, callback) => {
      const Reg = /^[a-zA-Z0-9'‐_.,:;\[\]{}()（）﹙﹚《》﹝﹞%+*!?\-@#$/=&°|、’‚–\t“”\" ]{1,200}$/
      if (!value) {
        return callback(new Error("Please input company name."))
      } else {
        if (Reg.test(value)) {
          checkCompany(value).then(res => {
            if (res.code == 500) {
              if (this.registerThree.companyName == "" || this.registerThree.companyName == 'new company') {
                return callback(new Error(res.msg))
              } else {
                callback()
              }
            } else {
              callback()
            }
          })
        } else {
          return callback(new Error('Cannot exceed over 200 characters and only supports English,digits and these specail characters: -_.,:;[]{}()（）《》﹝﹞%+*!?@#$=&|°、’‚–“”"' + "'"))
        }
      }
    }
    var companyPhone = (rule, value, callback) => {
      if (value && this.registerThreeFrom.companyAreaCode !== '') {
        if (value.length > 255) {
          return callback(new Error("Cannot exceed over 255 characters."))
        } else {
          return callback()
        }
      } else {
        return callback(new Error("Please input the phone number."))
      }
    }
    var checkAddress = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('Please input address.'))
      } else {
        if (value.length > 1000) {
          return callback(new Error("Cannot exceed over 1000 characters."))
        } else {
          return callback()
        }
      }
    }
    var checkPhone = (rule, value, callback) => {
      if (value && this.registerThreeFrom.areaCode !== '') {
        if (value.length > 255) {
          return callback(new Error("Cannot exceed over 255 characters."))
        } else {
          return callback()
        }
      } else {
        return callback(new Error("Please input the phone number."))
      }
    }
    var checkfirstName = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('Please input first name.'))
      } else {
        if (value.length > 255) {
          return callback(new Error("Cannot exceed over 255 characters."))
        } else {
          return callback()
        }
      }
    }
    var checklastName = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('Please input last name.'))
      } else {
        if (value.length > 255) {
          return callback(new Error("Cannot exceed over 255 characters."))
        } else {
          return callback()
        }
      }
    }
    return {
      select: '',
      registerThreeFrom: {
        password: "",
        confirmPassword: '',
        companyName: "",
        companyPhone: '',
        companyAreaCode: "",
        address: "",
        region: {},
        state: {},
        city: {},
        industry: '',
        firstName: '',
        lastName: "",
        phone: '',
        areaCode: '',
        isRegNewCompany: 0,
      },

      registerThreeRules: {
        password: [
          { required: true, validator: checkPassword, trigger: 'blur' }
        ],
        confirmPassword: [
          { required: true, validator: checkConfirmPas, trigger: 'blur' }
        ],
        companyName: [
          { required: true, validator: checkCompanyName, trigger: 'blur' }
        ],
        companyPhone: [
          { required: true, validator: companyPhone, trigger: ['blur'] }
        ],
        address: [
          { required: true, validator: checkAddress, trigger: 'blur' }
        ],
        region: [
          { required: true, message: 'Please select country/region.', trigger: 'change' }
        ],
        firstName: [
          { required: true, validator: checkfirstName, trigger: 'blur' }
        ],
        lastName: [
          { required: true, validator: checklastName, trigger: 'blur' }
        ],
        phone: [
          { required: true, validator: checkPhone, trigger: ['blur'] }
        ],
      },
      passwordType: 'password',
      confirmPassType: 'password',
      countryList: [],
      stateList: [],
      cityList: [],
      industryList: [],
      areaCodelist: [],
      companyAreaCode: [],
      industryProps: {
        value: 'id',
        label: 'name',
        children: 'list'
      },
      registerLoad: false,
    }
  },

  methods: {
        //获取国家列表
        getCountryList() {
      getCountry('country').then((res) => {
        this.countryList = res.rows
        this.$ls.set('country', res.rows)
      })
    },
        //获取一级行政区
        getStateList(val) {
      getStatesByGSMCountryId(val).then((res) => {
        this.stateList = res.rows
      })
    },
    //获取二级行政区
    getCityList(val) {
      getCity(val).then((res) => {
        this.cityList = res.rows
      })
    },



    //切换密码框密码显示隐藏
    passwordView () {
      this.passwordType = this.passwordType == 'password' ? 'text' : 'password';
    },
    confirmPassView () {
      this.confirmPassType = this.confirmPassType == 'password' ? 'text' : 'password';
    },
    //选择国家或地区，调用一级行政区
    changeCountry () {
      getState(this.registerThreeFrom.region.remark).then(res => {
        this.stateList = res.rows
        this.registerThreeFrom.state = {}
      })
    },
    //选择一级行政区，调用二级行政区
    changeState () {
      getCity(this.registerThreeFrom.state.value).then(res => {
        this.cityList = res.rows
        this.registerThreeFrom.city = {}
      })
    },
    //注册
    register (registerThreeFrom) {
      this.$refs[registerThreeFrom].validate(valid => {
        if (valid) {
          let params = JSON.parse(JSON.stringify(this.registerThreeFrom));
          params.email = this.registerThree.email;
          params.region = this.registerThreeFrom.region.value;//国家id
          params.countryName = this.registerThreeFrom.region.name;//国家名称
          params.statesId = this.registerThreeFrom.state.value;//一级行政区id
          params.statesName = this.registerThreeFrom.state.name;//一级行政区名称
          params.cityId = this.registerThreeFrom.city.value;//二级行政区id
          params.cityName = this.registerThreeFrom.city.name;//二级行政区名称
          params.password = registerEncrypt(params.password)
          params.industry = params.industry ? params.industry.join(',') : "";
          delete params.confirmPassword;
          delete params.state;
          delete params.city;
          this.registerLoad = true;
          register(params).then(res => {
            this.registerLoad = false;
            this.$message({
              type: 'success',
              message: res.msg,
            });
            this.$router.push({ path: '/login' })
          }).catch(() => {
            this.registerLoad = false;
          })
        }
      })
    },

    //过滤空的industry
    filterIndustry (data) {
      data.map(val => {
        if (val.list && val.list.length > 0) {
          this.filterIndustry(val.list)
        } else {
          delete val.list
        }
      })
      return data
    },

    //电话区号搜索
    remoteMethod (qurey) {
      this.areaCodelist = this.$ls.get('AreaCode')
      this.areaCodelist = this.areaCodelist.filter(val => {
        if ((val.country + " " + val.areaCode).toLowerCase().replace(/\s/g, "").indexOf(qurey.toLowerCase().replace(/\s/g, "")) != -1) {
          return true
        }
        return false
      })
    },
    areaCodeFocus (qurey) {
      setTimeout(() => {
        if (!qurey) {
          this.areaCodelist = this.$ls.get('AreaCode')
        }
      }, 200);
    },

    //获取公司信息
    getCorpByInfo (data) {
      getCorpByName(data).then(res => {
        let item = res.rows;
        this.registerThreeFrom.companyName = item.name;
        this.registerThreeFrom.companyAreaCode = item.areaCode;
        this.registerThreeFrom.companyPhone = item.phone;
        this.registerThreeFrom.address = item.address;
        this.registerThreeFrom.region = this.countryList.find(it =>it.value === item.region);
        this.registerThreeFrom.industry = item.industry ? item.industry.split(',') : [];
        this.registerThreeFrom.state = {value:item.statesId || '',name:item.statesName || ''};
        this.registerThreeFrom.city = {value:item.cityId || '',name:item.cityName || ''}
        this.getStateList(item.region)
        if(item.statesId){
          this.getCityList(item.statesId)
        } 
    })
    }
  },
  computed: {
    filterIndustryList () {
      return this.filterIndustry(this.industryList)
    }
  },

  created () {
    if (this.registerThree.companyName !== '' && this.registerThree.companyName !== 'new company') {
      this.registerThreeFrom.isRegNewCompany = 1;
      this.getCorpByInfo(this.registerThree.companyName)
    }
    this.countryList = this.$ls.get('country')
    this.industryList = this.$ls.get('industry')
    this.areaCodelist = this.$ls.get('AreaCode')
    console.log(this.registerThree);
    this.getCountryList()
  }
}
</script>

<style lang="scss" scoped>
.sp_registerThree {
  width: 100%;
  height: calc(100% - 94px);
  margin-top: 20px;
  padding: 0 104px;
  h3 {
    font-size: 16px;
    font-weight: 500;
    color: #13161a;
    height: 40px;
    line-height: 40px;
  }
  .el-form-item {
    margin-bottom: 24px !important;
  }
  /deep/.el-form-item__label {
    margin: 0 0 4px 0;
    font-size: 14px;
    font-weight: 400;
    height: 20px;
    line-height: 20px;
    color: #77808c;
  }
  .sp_telSelect {
    /deep/.el-input-group__prepend {
      width: 21%;
      background: #fff;
    }
    /deep/.el-input.is-disabled .el-input__inner {
      background-color: #f5f7fa;
      border: 1px solid #dcdfe6;
      border-left: none;
    }
  }
  .register {
    margin-top: 31px;
    display: flex;
    justify-content: center;
  }
  .sp_login_copyRight {
    text-align: center;
    color: #a1a8b3;
    font-size: 14px;
    opacity: 0.8;
    line-height: 20px;
    padding-bottom: 16px;
  }
  /deep/.el-select-dropdown__wrap {
    max-height: 284px !important;
  }
}
/deep/.el-select {
  .el-select__caret:first-child::before {
    content: "\e6e1";
  }
  .is-focus {
    .el-select__caret:first-child {
      transform: rotateZ(0deg);
    }
  }
}
.password-icon {
  height: 16px;
  width: 16px;
}
/deep/.input-with-select input::-webkit-outer-spin-button,
/deep/.input-with-select input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}
/deep/ .input-with-select input[type="number"] {
  -moz-appearance: textfield;
}
</style>